module.exports = {
  HARSH_BRAKING: 'harsh-braking',
  HARSH_ACCELERATION: 'harsh-acceleration',
  SHARP_TURN: 'sharp-turn',
  OVER_RPM: 'over-rpm',
  OVERSPEED: 'overspeed',
  IDLING_ENGINE_ON: 'idling-engine-on',
};
